const seeAllInstructionsLink = document.querySelector(".js-see-all-link-smooth-scroll-init");

if (seeAllInstructionsLink) {
    window.addEventListener("load", () => {
        seeAllInstructionsLink.addEventListener("click", (e) => {
            e.preventDefault();

            document
                .getElementById(e.target.dataset.id)
                .scrollIntoView({ behavior: "smooth", block: "center" });
        });
    });
}
